export default {
      id: "common__import_export-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__import_export",
      toString: function () {
        return this.url;
      }
    }